var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { LitElement } from 'lit';
import { property } from 'lit/decorators.js';
import { hostStyles } from '../../host.styles';
import { iconStyles } from './icon.styles';
export class IconBaseElement extends LitElement {
    constructor() {
        super(...arguments);
        /**
         * The size of the Icon
         */
        this.size = 's16';
        /**
         * tagging property used to use `*[zui-icon]` as a querySelector for zuiIcons
         */
        this.isIcon = true;
    }
    /**
     * Defines the styles of the base type
     */
    static get styles() {
        return [hostStyles, iconStyles];
    }
}
__decorate([
    property()
], IconBaseElement.prototype, "theme", void 0);
__decorate([
    property({ reflect: true })
], IconBaseElement.prototype, "size", void 0);
__decorate([
    property({ reflect: true, attribute: 'zui-icon', type: Boolean })
], IconBaseElement.prototype, "isIcon", void 0);
